import { api } from '@/services'
const qs = require('qs')

export function findAll(params) {
  return api.get('/admin/host/list', {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    },
  })
}
export function find(id) {
  return api.get(`/admin/host/show/${id}`)
}
export function findHostAccessControlHistory(id) {
  return api.get(`/admin/host/listSuspensionHistoryByUser/${id}`)
}
export function suspend(body) {
  return api.post('/admin/host/suspend', body)
}
export function unsuspend(body) {
  return api.post('/admin/host/unsuspend', body)
}
export function block(body) {
  return api.post('/admin/host/block', body)
}
export function unblock(body) {
  return api.post('/admin/host/unblock', body)
}
export function listServiceTypes() {
  return api.get('/admin/host/listServiceTypes')
}
export function create(body) {
  return api.post('/admin/host/create', body)
}
export function update(body, id) {
  return api.put(`/admin/host/update/${id}`, body)
}
export function remove(id) {
  return api.delete(`admin/host/delete/${id}`)
}
export function listHostAppointments(params) {
  return api.get('/admin/appointment/listHostAppointments', { params: params })
}
export function listHostPayments(params) {
  return api.get('admin/payment/listHostPayments', { params })
}
export function hostPaymentCreate(body) {
  return api.post('/admin/payment/createDetached', body)
}
export function linkHostAsaasAccount(body) {
  return api.post('/admin/asaas/linkAccount', body)
}
export function unlinkHostAsaasAccount(body) {
  return api.post('/admin/asaas/unlinkAccount', body)
}
export function createHostHistory(body) {
  return api.post('/admin/hostHistory/create', body)
}
export function listHostHistory(params) {
  return api.get('/admin/hostHistory/list', { params })
}
export function createHostOnChecklist(id) {
  return api.post(`/admin/host/createOnChecklist/${id}`)
}
export function listSpecialties(params) {
  return api.get('/admin/host/listSpecialties', { params })
}
export function listHostSpecialties(id) {
  return api.get(`/admin/host/specialties/${id}`)
}
export function updateHostSpecialties(id, body) {
  return api.put(`/admin/host/specialties/${id}`, body)
}

export function createSpecialty(body) {
  return api.post('/admin/host/specialties', body)
}

export function deleteSpecialty(id) {
  return api.delete(`/admin/host/specialties/${id}`)
}

export function getHostRealEstateBlacklist(hostId) {
  return api.get(`/admin/hostRealEstateBlacklist/${hostId}`)
}

export function addToHostRealEstateBlacklist(body) {
  return api.post('/admin/hostRealEstateBlacklist', body)
}

export function removeFromHostRealEstateBlacklist(id) {
  return api.delete(`/admin/hostRealEstateBlacklist/${id}`)
}

export function listHostFiles(hostId) {
  return api.get(`/admin/hostFile/${hostId}`)
}

/** Signed URL of the file. It expires, so it is fetched on every click. */
export function hostFileDownloadURL(hostId, fileId) {
  return api.get(`/admin/hostFile/${hostId}/file/${fileId}`)
}
